export default {
  GET_DEALER_USERS: (state) => state.dealerUsers,
  GET_ACTIVE_DEALER_USERS: (state) => state.dealerUsers.filter((dealerUser) => dealerUser.status),
  GET_DEALER_USER: (state) => state.dealerUser,
};
